(function () {
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init() {
    var form = qs('#ProductForm');
    if (!form) return;
    var root = form.closest('[data-product-section]') || document;

    /* ---------- Gallery ---------- */
    var thumbs = qsa('.product-thumb', root);
    var slides = qsa('.hp-slide', root);
    function showMedia(id) {
      if (!id) return;
      var found = slides.some(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (!found) return;
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id));
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-media-id')); });
    });

    /* ---------- Variants ---------- */
    var dataEl = qs('#ProductVariantsData');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    var groups = qsa('.variant-pills', form);
    var idInput = qs('#ProductVariantId', form);
    var atcBtn = qs('#AddToCartButton', form);
    var atcText = qs('#AddToCartText', form);
    var stickyBtn = qs('[data-sticky-atc]', root);
    var stickyPrice = qs('[data-sticky-price]', root);
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare]', root);
    var saveEl = qs('[data-save]', root);
    var labels = atcBtn ? {
      add: atcBtn.getAttribute('data-text-add'),
      sold: atcBtn.getAttribute('data-text-sold'),
      na: atcBtn.getAttribute('data-text-unavailable')
    } : {};

    function selection() {
      return groups.map(function (g) {
        var p = qs('.variant-pill.is-selected', g);
        return p ? p.getAttribute('data-value') : null;
      });
    }
    function matches(v, sel, skipIndex) {
      return sel.every(function (val, i) {
        return i === skipIndex || val === null || v.options[i] === val;
      });
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], sel, -1)) return variants[i];
      }
      return null;
    }
    function markAvailability() {
      var sel = selection();
      groups.forEach(function (g, gi) {
        qsa('.variant-pill', g).forEach(function (pill) {
          var val = pill.getAttribute('data-value');
          var test = sel.slice();
          test[gi] = val;
          var ok = variants.some(function (v) { return v.available && matches(v, test, -1); });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function setBtn(btn, disabled, text, textEl) {
      if (!btn) return;
      btn.disabled = disabled;
      if (textEl) textEl.textContent = text;
    }
    function update(v) {
      if (!v) {
        setBtn(atcBtn, true, labels.na, atcText);
        setBtn(stickyBtn, true, labels.na, stickyBtn);
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare || '';
        compareEl.hidden = !v.compare;
      }
      if (saveEl) {
        saveEl.textContent = v.save || '';
        saveEl.hidden = !v.save;
      }
      var txt = v.available ? labels.add : labels.sold;
      setBtn(atcBtn, !v.available, txt, atcText);
      setBtn(stickyBtn, !v.available, txt, stickyBtn);
      if (v.media) showMedia(v.media);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    groups.forEach(function (group, gi) {
      var pills = qsa('.variant-pill', group);
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-pressed', 'true');
          var label = qs('[data-option-selected="' + gi + '"]', root);
          if (label) label.textContent = pill.getAttribute('data-value');
          markAvailability();
          update(findVariant(selection()));
        });
      });
    });
    if (groups.length) markAvailability();

    /* ---------- Quantity ---------- */
    var qty = qs('#ProductQty', form);
    qsa('[data-qty-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
        var next = (parseInt(qty.value, 10) || 1) + step;
        qty.value = Math.max(1, next);
      });
    });

    /* ---------- Subscribe & save ---------- */
    var planSelect = qs('#SellingPlanSelect', form);
    qsa('input[name="purchase_type"]', form).forEach(function (radio) {
      radio.addEventListener('change', function () {
        var sub = radio.checked && radio.value === 'subscribe';
        var box = qs('.hp-sub', form);
        if (planSelect && radio.checked) planSelect.disabled = !sub;
        if (box && radio.checked) box.classList.toggle('is-sub', sub);
      });
    });

    /* ---------- Sticky add-to-cart bar ---------- */
    var bar = qs('#StickyBar', root);
    if (bar && atcBtn) {
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        });
        io.observe(atcBtn);
      }
    }

    /* ---------- Recommendations fallback ---------- */
    var recs = qs('[data-recs-url]', root);
    if (recs && window.fetch) {
      fetch(recs.getAttribute('data-recs-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-recs-grid]');
          if (src && src.children.length) {
            var dest = recs.querySelector('[data-recs-grid]');
            if (dest) dest.innerHTML = src.innerHTML;
            recs.hidden = false;
          }
        })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
